import React from 'react';

import {
  TextCustom,
  TextAppearance,
  Breakpoints,
  TextSize,
  TextWeight,
  TextColor,
  TextLineHeight,
} from '@vw-marketing/us-components';

import { RichTextRenderer } from '../../../utils/richTextRenderer';
import { StyledVehicleInformationContainer } from './styled';

interface VehicleInformationContainerProps {
  id: string;
  modelName: string;
  modelYear: string;
  userRole: string;
  vin: string;
  fromRemoveVehicle?: boolean;
}

export const VehicleInformationContainer = ({
  id,
  modelName,
  modelYear,
  userRole,
  vin,
  fromRemoveVehicle = false,
}: VehicleInformationContainerProps) => {
  const vehicleVariables = {
    year_model: {
      value: `${modelYear} ${modelName}`,
      noTranslate: true,
    },
  };

  return (
    <StyledVehicleInformationContainer
      key={id}
      data-testid="vehicle-info-container"
    >
      <TextCustom
        appearance={TextAppearance.label100}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize12,
            fontWeight: TextWeight.bold,
            color: TextColor.secondary,
            lineHeight: TextLineHeight.TextLineHeight16,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize14,
            fontWeight: TextWeight.bold,
            color: TextColor.secondary,
            lineHeight: TextLineHeight.TextLineHeight16,
          },
        }}
      >
        {userRole && !fromRemoveVehicle ? userRole : ''}
      </TextCustom>
      <TextCustom
        appearance={TextAppearance.headline200}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize20,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize24,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight28,
          },
        }}
      >
        <RichTextRenderer text="${year_model}" variables={vehicleVariables} />
      </TextCustom>
      <TextCustom
        appearance={TextAppearance.copy100}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize14,
            fontWeight: TextWeight.light,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize16,
            fontWeight: TextWeight.light,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
        }}
      >
        <span className="notranslate">VIN {vin}</span>
      </TextCustom>
    </StyledVehicleInformationContainer>
  );
};
